let leaseFlow = [
    { title: "1、签约注册：", content: "客户与普拉托签订《普托邦会员服务协议》，并在普拉托运营的“普托e享”专用系统注册账号，用于业务操作。" },
    { title: "2、起租申请：", content: "客户通过合同约定方式向普拉托提出托盘起租申请；" },
    { title: '3、物流配送：', content: "普拉托确认起租需求后，安排车辆将租赁托盘配送至客户指定地点，客户也可选择自行到普拉托营运服务中心提取托盘；" },
    { title: "4、退租申请：", content: "客户通过合同约定方式向普拉托提出托盘退租申请；" },
    { title: "5、物流回收：", content: "普拉托确认退租需求后，安排车辆从客户指定地点回收租赁托盘，客户也可选择自行归还托盘到普拉托营运服务中心；" },
    { title: "6、对账结算：", content: "租赁期内，客户全部租赁合约按月度进行对账结算。" }
],
    // 费用说明
    chargeDescList = [
        { title: '1、押金', content: [{ desc: '在租赁托盘交付前，客户需向普拉托缴纳押金，缴纳比例根据客户资质约定。押金在客户归还设备并清缴全部应付款项后无息退还。' }] },
        {
            title: "2、租费", content: [
                { desc: '托盘租费包括租赁租金及租赁服务费。' },
                { desc: '（1）租金：指托盘的租赁使用费。' },
                { desc: '（2）服务费：指平台租赁清算服务费及常规损坏维护费。' }
            ]
        },
        {
            title: "3、运费", content: [{
                desc: "普拉托根据客户起退租需求提供上门配送回收服务收取的物流运输费用。"
            }]
        },
        {
            title: "4、其他费用", content: [
                { desc: '指租赁业务过程中可能产生的清洗费、转户费、异地归还费等费用。' },
                { desc: '（1）清洗费：客户直接或间接归还托盘时，因托盘出现污损而向普拉托支付的托盘清洁服务费用。' },
                { desc: '（2）转户费：客户通过普拉托专用系统将托盘承租权利及义务转移给第三方时，应向普拉托支付的转户服务费用。' },
                { desc: '（3）异地归还费：客户起租地与归还地不一致时（指跨省），因涉及异地仓库调度而向普拉托支付的异地归还服务费用。' },
                { desc: '（4）双方约定的除以上几项外的其他费用。' },

            ]
        },
    ],
    // 对账及租金支付
    rentPayment = [
        { title: "1、 账单：", content: "账单包含一个账单期内，客户全部租赁合约应付费用之和，账单期为上一账单日到本账单日前一天。" },
        { title: "2、 对账：", content: "租赁存续期内，每月1日或20日为系统账单日。客户核对确认账单后或在约定期限内未对账单提出异议的，普拉托将据此开具发票。" },
        { title: "3、 付款周期：", content: "账单付款周期为20天，根据账单日不同，每月20日或次月10日为账单最后支付日。" },
    ],

    // 常见问题
    question = [
        {
            title: "1、单批托盘租赁具体起租、退租日怎么确定？租金怎么计算？",
            content: [
                { desc: '单批托盘交付给客户指定代理人的日期为起租日，起租日当天开始计租；普拉托在指定营运中心确认接收归还托盘的日期或归还托盘转付经普拉托公司同意的第三方的日期为退租日，退租日次日起停止计租。' }
            ]
        },
        {
            title: "2、在有多份单笔租赁合约的情况下，归还托盘时怎么确定还的是哪一份租赁合约？",
            content: [
                { desc: '托盘归还时，客户可以指定归还特定合约，在客户不指定的情况下按系统默认顺序自动归还，即根据合约产生的先后顺序按期限、产品优先级依次选择合约；' },
                { boldText: '期限优先级：', bold: "未约定期限的合约>约定期限并到期的合约>约定期限未到期的合约；" },
                { boldText: '产品优先级：', bold: "随心托>普惠托（超期价格不变）>普惠托（超期按阶梯计费）>定义托（超期价格不变）>定义托（超期按阶梯计费）>快易托顺序选择合约" },
                { desc: '例1：A公司有四份单次租赁合约，其中1号合约为3月起租的1000片已到期普惠托合约，2号合约为1月起租的500片未到期普惠托合约，3号合约为4月起租的500片未到期普惠托合约，4号合约为5月起租的1000片不约定期限的随心托合约。' },
                { desc: '客户进行2500片托盘归还，最先归还的是不约定期限的4号合约中的1000片，其次归还到期的1号合约中的1000片，再归还未到期普惠托合约中起租时间更早的2号合约的500片。' },
                { desc: '例2：B公司有五份单次租赁合约，其中1号合约为5月起租的1000片已到期定易托合约，2号合约为6月起租的1000片未到期定易托合约，3号合约为7月起租的500片未到期普惠托合约，4号合约为5月起租的500片已到期普惠托合约。' },
                { desc: '客户进行2000片托盘归还，最先归还的是已到期的4号合约中的500片，其次归还已到期的1号合约中的1000片，最后归还未到期的3号合约中的500片。' }
            ]
        },
        {
            title: '3、异地归还的服务范围？',
            content: [
                { desc: '（1）归还设备的地点合同有约定的以约定为准；未约定或约定不明的以普拉托官方网站、企业公众号、信息系统客户端公告公示的服务覆盖范围为准；' },
                { desc: '（2）带托运输至异地归还或转付给第三方客户归还的，归还地址只要是普拉托公示的服务覆盖范围内都可以。' },
            ]
        },
        {
            title: '4、租赁托盘使用中出现破损怎么办？',
            content: [
                { desc: '租赁期间，托盘正常使用损耗免赔；由于人为操作不当或故意损坏造成破损的，需负责损坏托盘的维修复原或照价赔偿。' }
            ]
        },
        {
            title: '5、租赁托盘丢失如何处理？',
            content: [
                { desc: '租赁托盘发生整体丢失或灭失时，需立即通知普拉托并照价赔偿，普拉托收到赔偿金后即停止对丢失/灭失托盘进行计租。' }
            ]
        },
        {
            title: "6、租用的地区比较偏远或者要分为多个地方收货，是否能送货，费用由谁承担？",
            content: [
                { desc: "在约定的服务范围内，普拉托可提供上门配送及回收，超出服务范围的需要客户自行到普拉托营运服务中心提取或归还，配送回收产生的费用由客户承担。" }
            ]
        },{
            title: "7、起租时托盘有些破损怎么办，后面退租时会有争议吗？",
            content: [
                { desc: "普拉托托盘起租发货以能正常使用为标准，使用期间，正常破损免赔，客户无需顾忌因起租时有些许破损而产生后续退租纠纷。如若起租时或使用期间，因托盘破损导致无法正常使用，可以在专用系统进行报损，并上传破损图片，报备破损的托盘将在报备成功当日停止计租，但客户仍负有保管责任，并在后续归还时正常归还。" }
            ]
        }
    ]


export { leaseFlow, chargeDescList, rentPayment, question }